(function () {

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function findFacetFormFromInput(input) {
    const closestForm = input.closest('form');
    if (closestForm) return closestForm;

    return (
      document.querySelector('.facets form') ||
      document.querySelector('facet-filters-form form') ||
      document.querySelector('form[action*="/collections/"]')
    );
  }

  function shouldHandleInput(input) {
    if (!input) return false;
    if (input.type !== 'checkbox' && input.type !== 'radio') return false;

    const name = input.getAttribute('name') || '';

    const isFilter =
      name.startsWith('filter.') ||
      name.startsWith('filter.v.') ||
      name.includes('filter') ||
      name === 'sort_by';

    return isFilter;
  }

  function bindInstantFilters() {

    const inputs = document.querySelectorAll('input[type="checkbox"], input[type="radio"]');

    inputs.forEach((input) => {

      if (!shouldHandleInput(input)) return;
      if (input.dataset.instantBound === 'true') return;

      input.dataset.instantBound = 'true';

      input.addEventListener('change', () => {

        // 🚫 MOBILE → não faz nada (deixa botão Aplicar agir)
        if (!isDesktop()) return;

        const form = findFacetFormFromInput(input);
        if (!form) return;

        setTimeout(() => {

          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          }

        }, 0);
      });

    });
  }

  document.addEventListener('DOMContentLoaded', bindInstantFilters);

  const observer = new MutationObserver(() => bindInstantFilters());
  observer.observe(document.documentElement, { childList: true, subtree: true });

})();
